import { AppBookAddressComponent } from './../profile-user/app-book-address/app-book-address.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';

@Component({
  selector: 'meu-app-cart-modal-change-address',
  templateUrl: './app-cart-modal-change-address.component.html',
  styleUrls: ['./app-cart-modal-change-address.component.scss']
})
export class AppCartModalChangeAddressComponent implements OnInit {
  @ViewChild('appBookAddressComponent', { static: false })
  appBookAddressComponent: AppBookAddressComponent;
  @ViewChild('newAddressTabComponent', { static: false })
  newAddressTabComponent: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AppCartModalChangeAddressComponent>,
  ) { }
  addressID: any = "";
  addressOutput: any = null;
  isEditingAddress: boolean = false;
  isCreateAddress: boolean = false;
  lstAddress: any = [];
  isCreateDone: boolean = false;
  ngOnInit() {
    if (this.data.checkedAddress != undefined) {
      this.addressID = this.data.checkedAddress.id;
    }

    if (this.data.lstMyAddress && this.data.lstMyAddress.length == 0) {
      this.isCreateAddress = true;
    }
  }
  updateComponent(event) {
    this.addressOutput = event;
    if (this.addressOutput.length == 0) {
      this.isCreateAddress = true;
    }
  }
  openFormCreateDesktop() {
    this.isCreateAddress = true;
  }
  cancelEditAddress() {
    if (this.appBookAddressComponent) {
      this.appBookAddressComponent.cancelEditModal();
      this.appBookAddressComponent.closeModalCreate = true;
    }
    this.isCreateAddress = false;
  }
  cancelCreateAddress() {

  }
  closeModalChangeAddress() {
    this.dialogRef.close({ event: false, });
  }
  updateAddressID($event) {
    this.addressID = $event;
  }
  saveAddressShip() {
    this.dialogRef.close({ event: true, addressID: this.addressID, addressOutput: this.addressOutput });
  }
  updateAddress() {
    this.appBookAddressComponent.updateMyAddress();
  }
  createAddress() {
    if (this.newAddressTabComponent) {
      this.newAddressTabComponent.createMyNewAddress();
    }
  }
  checkCreate(event) {
    if (event) {
      this.isCreateAddress = false;
      if (this.appBookAddressComponent) {
        this.appBookAddressComponent.getAllMyAddress();
      }
    }
  }
}
